<template>
    <div class="add-project-page">
        <!-- 内容区 -->
        <div class="page-content">
            <!-- 项目名称 -->
            <div class="section-block">
                <div class="section-block-title">
                    <span class="title-bar"></span>
                    <span class="title-text">项目信息</span>
                </div>
                <div class="form-row">
                    <label class="form-label"><span class="required">*</span>项目名称</label>
                    <el-input v-model="form.projectName" placeholder="请输入项目名称" class="form-input" />
                </div>
            </div>
            <!-- 三个下拉（均分布局） -->
            <div class="dropdown-group">
                <div class="group-item">
                    <label class="group-label">不在本平台下载</label>
                    <el-select v-model="form.notOnPlatform" class="group-select">
                        <el-option label="否" value="否" />
                        <el-option label="是" value="是" />
                    </el-select>
                </div>
                <div class="group-item">
                    <label class="group-label">是否上传文件</label>
                    <el-select v-model="form.uploadFile" class="group-select">
                        <el-option label="否" value="否" />
                        <el-option label="是" value="是" />
                    </el-select>
                </div>
                <div class="group-item">
                    <label class="group-label">是否需要报名</label>
                    <el-select v-model="form.needSignup" class="group-select">
                        <el-option label="否" value="否" />
                        <el-option label="是" value="是" />
                    </el-select>
                </div>
            </div>
            <!-- 标段名称 -->
            <div class="section-block">
                <div class="section-block-title">
                    <span class="title-bar"></span>
                    <span class="title-text">标段名称</span>
                </div>
                <div class="section-header">
                    <span class="add-link" @click="handleAddSection">
                        <i class="el-icon-plus"></i> 添加标段
                    </span>
                </div>
                <div class="section-list">
                    <div class="section-item" v-for="(item, index) in sectionList" :key="index">
                        <el-input v-model="item.name" placeholder="请输入标段名称" class="section-name" />
                        <el-button v-if="form.uploadFile === '是'" class="upload-btn"
                            @click="handleUploadSection(index)">
                            <i class="el-icon-upload2"></i> 上传文件
                        </el-button>
                        <span class="field-tag">标书款</span>
                        <el-input v-model="item.bidDocFee" class="field-input" placeholder="0" />
                        <span class="field-unit">元</span>
                        <span class="field-tag">图纸押金</span>
                        <el-input v-model="item.drawingDeposit" class="field-input" placeholder="0" />
                        <span class="field-unit">元</span>
                    </div>
                </div>
            </div>

            <!-- 分隔线 -->
            <div class="divider"></div>

            <!-- 报名资料设置 -->
            <div class="section-block" v-if="form.needSignup === '是'">
                <div class="section-block-title">
                    <span class="title-bar"></span>
                    <span class="title-text">报名资料设置</span>
                </div>
                <div class="table-box">
                    <div class="table-header">
                        <span class="table-title">报名资料列表</span>
                        <span class="add-link" @click="handleAddMaterial">
                            <i class="el-icon-plus"></i> 添加资料
                        </span>
                    </div>
                    <div class="data-table">
                        <div class="data-row data-row--head">
                            <div class="col col-no">NO.</div>
                            <div class="col col-name">资料名称</div>
                            <div class="col col-desc">资料描述</div>
                            <div class="col col-remark">备注</div>
                            <div class="col col-action">操作</div>
                        </div>
                        <div class="data-row" v-for="(item, index) in materialList" :key="index">
                            <div class="col col-no">{{ index + 1 }}</div>
                            <div class="col col-name">
                                <el-input v-model="item.name" placeholder="资料名称" size="small" />
                            </div>
                            <div class="col col-desc">
                                <el-input v-model="item.desc" placeholder="资料描述" size="small" />
                            </div>
                            <div class="col col-remark">
                                <el-input v-model="item.remark" placeholder="备注" size="small" />
                            </div>
                            <div class="col col-action">
                                <span class="del-link" @click="handleDeleteMaterial(index)">删除</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 分隔线 -->
            <div class="divider"></div>

            <!-- 其他设置 -->
            <div class="section-block">
                <div class="section-block-title">
                    <span class="title-bar"></span>
                    <span class="title-text">其他设置</span>
                </div>
                <div class="table-box">
                    <div class="table-header table-header--simple">
                        <span class="table-title-sm">标书缴费说明</span>
                    </div>
                    <div class="textarea-row">
                        <el-input v-model="form.paymentDesc" type="textarea" :rows="2"
                            placeholder="可选填，投标人缴纳标书款时可见，如缴费方式等" class="payment-area" />
                        <el-button class="attach-btn" @click="handleUploadAttach">
                            <i class="el-icon-upload2"></i> 上传附件
                        </el-button>
                    </div>
                </div>
            </div>
              <!-- 底部操作栏 -->
        <div class="page-footer">
            <el-button class="btn-submit" @click="handleSubmit">提交</el-button>
            <el-button class="btn-save" @click="handleSave">保存</el-button>
            <el-button class="btn-cancel" @click="handleBack">取消</el-button>
        </div>

        </div>
      
    </div>


</template>

<script>
export default {
    name: 'AddProject',

    data() {
        return {
            form: {
                projectName: '',
                notOnPlatform: '否',
                uploadFile: '否',
                needSignup: '是',
                paymentDesc: ''
            },
            sectionList: [
                { name: '', bidDocFee: '', drawingDeposit: '' }
            ],
            materialList: [
                { name: '', desc: '', remark: '' }
            ]
        }
    },

    methods: {
        handleBack() {
            this.$router.push('/agentHome/semiProcess')
        },

        handleUploadSection(index) {
            this.$message.info(`上传第 ${index + 1} 个标段文件`)
        },

        handleUploadAttach() {
            this.$message.info('上传附件')
        },

        handleAddSection() {
            this.sectionList.push({ name: '', bidDocFee: '', drawingDeposit: '' })
        },

        handleAddMaterial() {
            this.materialList.push({ name: '', desc: '', remark: '' })
        },

        handleDeleteMaterial(index) {
            if (this.materialList.length === 1) {
                this.$message.warning('至少保留一条资料')
                return
            }
            this.materialList.splice(index, 1)
        },

        handleSubmit() {
            this.$message.success('提交成功')
        },

        handleSave() {
            this.$message.success('保存成功')
        }
    }
}
</script>

<style lang="less" scoped>
// ===== 整体布局 =====
.add-project-page {
    background: #F2F4F7;
    min-height: 100vh;
    padding-bottom: 90px;
}

.page-wrapper {
    width: 100%;
    margin: 0 auto;
    padding: 0 16px;
}

.page-content {
    background: #fff;
    border-radius: 4px;
    padding: 28px 32px;
}

// ===== 区块通用 =====
.section-block {
    margin-bottom: 4px;
}

.section-block-title {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
}

.title-bar {
    width: 3px;
    height: 16px;
    background: #409EFF;
    border-radius: 2px;
    margin-right: 8px;
    flex-shrink: 0;
}

.title-text {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
}

.divider {
    height: 1px;
    background: #EFF6FF;
    margin: 20px 0;
}

// ===== 表单行 =====
.form-row {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
}

.form-label {
    width: 90px;
    flex-shrink: 0;
    font-size: 14px;
    color: #606266;
    text-align: right;
    padding-right: 12px;
    line-height: 32px;

    .required {
        color: #F56C6C;
        margin-right: 2px;
    }
}

.form-value {
    flex: 1;
    max-width: 480px;
}

.form-input {
    /deep/ .el-input__inner {
        height: 32px;
        border-radius: 2px;
        border-color: #DCDFE6;
        font-size: 14px;
    }
}

// ===== 三个下拉（均分布局） =====
.dropdown-group {
    margin-top: 20px;
    display: flex;
    gap: 24px;
    background: #eaeef7;
    border-radius: 8px;
    padding: 18px 24px;
    margin-bottom: 20px;
    
}

.group-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.group-label {
    font-size: 13px;
    color: #606266;
    font-weight: 500;
}

.group-select {
    width: 100%;
}

// ===== 标段区 =====
.section-header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 12px;
}

.add-link {
    color: #409EFF;
    font-size: 13px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-weight: bold;

    &:hover {
        opacity: 0.75;
    }
}

.section-list {
    border: 1px solid #EBEEF5;
    border-radius: 4px;
    overflow: hidden;
}

.section-item {
    display: flex;
    align-items: center;
    gap: 0;
    padding: 12px 16px;
    border-bottom: 1px solid #F2F6FC;

    &:last-child {
        border-bottom: none;
    }
}
.section-name {
    width: 200px;
    margin-right: 8px;
    flex-shrink: 0;

    /deep/ .el-input__inner {
        height: 30px;
        border-radius: 2px;
        font-size: 13px;
    }
}

.upload-btn {
    height: 30px;
    border-radius: 2px;
    font-size: 12px;
    color: #606266;
    border-color: #DCDFE6;
    background: #FAFAFA;
    margin-right: 10px;
    padding: 0 10px;
    flex-shrink: 0;

    /deep/ i {
        margin-right: 4px;
        color: #409EFF;
    }

    &:hover {
        color: #409EFF;
        border-color: #C6E2FF;
        background: #ECF5FF;
    }
}

.field-tag {
    font-size: 13px;
    color: #909399;
    margin: 0 6px 0 12px;
    flex-shrink: 0;
    min-width: 42px;
}

.field-input {
    width: 80px;
    margin-right: 4px;
    flex-shrink: 0;

    /deep/ .el-input__inner {
        height: 30px;
        border-radius: 2px;
        text-align: left;
        font-size: 13px;
    }
}

.field-unit {
    font-size: 13px;
    color: #909399;
    margin-right: 16px;
    flex-shrink: 0;
}

// ===== 表格 =====
.table-box {
    border: 1px solid #EBEEF5;
    border-radius: 4px;
    overflow: hidden;
}

.table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    background: #FAFAFA;
    border-bottom: 1px solid #EBEEF5;

    &--simple {
        background: #FAFAFA;
    }
}

.table-title {
    font-size: 14px;
    color: #303133;
    font-weight: 500;
}

.table-title-sm {
    font-size: 13px;
    color: #303133;
    font-weight: 500;
}

.data-table {
    background: #fff;
}

.data-row {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #EBEEF5;

    &:last-child {
        border-bottom: none;
    }

    &--head {
        background: #FAFAFA;
        color: #909399;
        font-size: 13px;
    }
}

.col {
    padding: 10px 12px;
    box-sizing: border-box;

    &.col-no {
        width: 52px;
        text-align: center;
        flex-shrink: 0;
    }

    &.col-name {
        flex: 1;
        min-width: 160px;
    }

    &.col-desc {
        flex: 1;
        min-width: 180px;
    }

    &.col-remark {
        flex: 1;
        min-width: 160px;
    }

    &.col-action {
        width: 72px;
        text-align: center;
        flex-shrink: 0;
    }
}

.data-row--head .col {
    padding: 10px 12px;
}

.del-link {
    color: #F56C6C;
    font-size: 13px;
    cursor: pointer;
    font-weight: bold;

    &:hover {
        opacity: 0.75;
    }
}

// ===== 文本域 =====
.textarea-row {
    display: flex;
    align-items: flex-start;
    padding: 14px 16px;
    gap: 12px;
}

.payment-area {
    flex: 1;

    /deep/ .el-textarea__inner {
        border-radius: 2px;
        min-height: 52px;
        font-size: 13px;
        resize: none;
    }
}

.attach-btn {
    height: 52px;
    border-radius: 2px;
    border-color: #DCDFE6;
    color: #606266;
    font-size: 13px;
    white-space: nowrap;
    flex-shrink: 0;
    padding: 0 14px;

    /deep/ i {
        margin-right: 4px;
    }
}

// ===== 底部 =====
.page-footer {
    display: flex;
    justify-content: center;
    gap: 14px;
    padding: 14px 0;
    background: #fff;
}

.btn-submit,
.btn-save,
.btn-cancel {
    min-width: 96px;
    height: 34px;
    border-radius: 2px;
    font-size: 14px;
    font-weight: 500;
    padding: 0 24px;
}

.btn-submit {
    background: #1890FF;
    border-color: #1890FF;
    color: #fff;

    &:hover {
        background: #40A9FF;
        border-color: #40A9FF;
    }
}

.btn-save {
    background: #52C41A;
    border-color: #52C41A;
    color: #fff;

    &:hover {
        background: #73D13D;
        border-color: #73D13D;
    }
}

.btn-cancel {
    background: #fff;
    border-color: #DCDFE6;
    color: #606266;

    &:hover {
        color: #409EFF;
        border-color: #409EFF;
    }
}
</style>
